export const SITE_URL = ((import.meta.env.VITE_SITE_URL as string) || 'https://allchinabuyspread.pics').replace(/\/+$/, '');

export const SITE_NAME = 'AllChinaBuy Spreadsheet';